export default __webpack_public_path__ + "static/media/threebigcards_retail_1.39380a3b.png";